<template lang="pug">
  #wellness-member-overview-metric-progress.is-flex.is-flex-direction-column.is-justify-content-center
    BTooltip(
      :active="false"
      label=""
      position="is-top"
      animated
    )
      VmProgress(
        type="circle"
        :percentage="metricPercentage"
        :strokeColor="strokeColor"
        :stroke-width="9"
        :width="100"
      )
        BIcon(
          v-if="metricPercentage === 100"
          icon="check"
          type="is-special-success"
          size="is-large"
        )
        .is-flex.is-justify-content-space-around(v-else)
          WtSvgIcon.p-4.has-border-radius-circle(
            :style="{'background': strokeColor}"
            :icon="icon"
            width="40px"
            height="40px"
          )
    .is-size-4 {{ metricTitle }}
    .is-size-7.has-text-grey.has-text-centered
      p {{ pointsTotalAwardedFor }} challenge points
      p of {{ pointsPossibleFor }} possible

</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "WellnessMemberOverviewMetricProgress",

  components: {
    WtSvgIcon
  },

  props: {
    metricTitle: {
      type: String,
      required: true
    },
    pointsTotalAwardedFor: {
      type: Number,
      required: true
    },
    pointsPossibleFor: {
      type: Number,
      required: true
    },
    strokeColor: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    metricPercentage: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="sass" scoped>
#wellness-member-overview-metric-progress
  .has-border-radius-circle
    border-radius: 100%
</style>
